export const STATUS = {
  ORCAMENTO:   { l: 'Orcamento',   cor: '#6b7280', bg: '#f3f4f6' },
  CONFIRMADO:  { l: 'Confirmado',  cor: '#1d4ed8', bg: '#dbeafe' },
  EM_PRODUCAO: { l: 'Em Producao', cor: '#92400e', bg: '#fef3c7' },
  PRONTO:      { l: 'Pronto',      cor: '#065f46', bg: '#d1fae5' },
  ENTREGUE:    { l: 'Entregue',    cor: '#15803d', bg: '#dcfce7' },
  CANCELADO:   { l: 'Cancelado',   cor: '#dc2626', bg: '#fee2e2' },
};
export const STATUS_KEYS = Object.keys(STATUS);
export const MESES = ['Janeiro','Fevereiro','Marco','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
export const CANAIS = [
  { v: 'CONSUMIDOR', l: 'Consumidor Final' },
  { v: 'ARQ_ENG',    l: 'Arq/Eng' },
  { v: 'REVENDEDOR', l: 'Revendedor' },
  { v: 'LOJISTA',    l: 'Lojista' },
  { v: 'ATACADISTA', l: 'Atacadista' },
];
export const CANAL_PRECO = { CONSUMIDOR:'CONSUMIDOR', ARQ_ENG:'ARQ_ENG', REVENDEDOR:'REVENDEDOR', LOJISTA:'LOJISTA', ATACADISTA:'ATACADISTA' };
export const PEDIDO_VAZIO = { canal:'', cliente:'', data_pedido:'', prazo_previsto:'', status:'ORCAMENTO', tipo_entrega:'ENTREGA', endereco_entrega:'', tem_servico:false, valor_servico:'0', desconto:'0', observacoes:'', tags_internas:'', valor_produtos:'0', valor_total:'0' };
export const ITEM_VAZIO = { produto:'', quantidade:'1', preco_unit:'0', desconto:'0', valor_total:'0', observacao:'' };
